import React, { useEffect } from "react";
import { Controller } from "react-hook-form";
import { Autocomplete, Box, CircularProgress, TextField } from "@mui/material";
import { useGetSuppliersHandler } from "../../resources/suppliers/dataHandlers/getSuppliersHandler";
import useSupplierFilters from "../../resources/suppliers/components/SupplierFilterHelper";

const SupplierProfileSelect = ({
  label = "Billed by",
  name,
  control,
  errors,
  readOnly = false,
  onSupplierLoaded,
}) => {
  const { currentQuery, handleSearchChange } = useSupplierFilters({
    defaultQuery: {},
    searchOnChange: true,
  });

  const { suppliers, isLoading } = useGetSuppliersHandler({
    searchQuery: currentQuery,
  });
  const getSupplierOptionLabel = (option) => {
    return `${option?.name || ""} | ${option?.email || ""} | ${option?.party_tax_scheme?.company_id || ""}`;
  };

  useEffect(() => {
    if (suppliers) {
      onSupplierLoaded?.(suppliers);
    }
  }, [onSupplierLoaded, suppliers]);

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <Box display="flex" alignItems="flex-start" gap={2}>
          <Autocomplete
            loading={isLoading}
            {...field}
            id={name}
            fullWidth
            readOnly={readOnly}
            options={suppliers || []}
            getOptionLabel={getSupplierOptionLabel}
            getOptionKey={(option) => option?.id}
            renderInput={(params) => (
              <TextField
                {...params}
                label={label}
                error={!!errors}
                helperText={errors || ""}
                slotProps={{
                  input: {
                    ...params.InputProps,
                    endAdornment: (
                      <React.Fragment>
                        {isLoading ? (
                          <CircularProgress color="inherit" size={20} />
                        ) : null}
                        {params.InputProps.endAdornment}
                      </React.Fragment>
                    ),
                  },
                }}
              />
            )}
            isOptionEqualToValue={(option, value) => option.id === value?.id} // Compare unique IDs
            onChange={(_, value) => field.onChange(value)}
            value={field.value || null}
            onInputChange={(event, value, reason) => {
              if (reason === "input") {
                handleSearchChange(event);
              }
            }}
            filterOptions={(x) => x}
          />
        </Box>
      )}
    />
  );
};

export default SupplierProfileSelect;
